import { AxiosResponse } from 'axios';
import { put } from 'redux-saga/effects';
import { api } from '../../libs';
import { loginError } from '../actions/auth';
import {
  fetchGeneralStatsSuccess,
  fetchPlaceStatsSuccess,
  IGeneralStatsRequestAction,
  IPlaceStatsRequestAction,
  statsError,
} from '../actions/stats';

export function* fetchGeneralStatsSaga(action: IGeneralStatsRequestAction) {
  try {
    const response: AxiosResponse = yield api.stats.getGeneralStats(
      action.payload ? action.payload.stepBy : undefined,
      action.payload ? action.payload.from : undefined,
      action.payload ? action.payload.to : undefined
    );

    const fetchedSummary = response.data.stats;
    yield put(fetchGeneralStatsSuccess(fetchedSummary));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(statsError(err.message));
    }
  }
}

export function* fetchPlaceStatsSaga(action: IPlaceStatsRequestAction) {
  try {
    const response: AxiosResponse = yield api.stats.getPlaceStats();

    const fetchedStats = response.data.stats;
    yield put(fetchPlaceStatsSuccess(fetchedStats));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(statsError(err.message));
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/stats.ts